import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (min-width: 200px) and (max-width: 399px) {
    min-height: 400px;
    text-align: center;
  }

  @media (min-width: 400px) and (max-width: 799px) {
    min-height: 400px;
    text-align: center;
  }

  @media (min-width: 800px) {
    min-height: 400px;
    text-align: center;
  }
`;

export const ContainerModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
  width: 100%;
`;

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column; // sempre coluna
  align-items: flex-start;
  width: 100%;
  gap: 4px;
`;

export const ItemTextModal = styled.div`
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;

export const TextModal = styled.div`
  color: rgba(0, 0, 0, 0.65);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  text-align: left;
  margin-top: 4px;
`;
